export type SitePowerNumberResponse = {
    value: number;
};

export class SitePowerNumberRequest {
    public constructor(
        public akc: string,
        public unit: string,
        public precision: number
    ) {
    }
}